/**
 * Canonical URL form of a project or module name.
 *
 * Access tokens name things the way people say them — "Production Toolkit",
 * "Station 60" — while a URL segment can't carry a space without becoming
 * "%20". An encoded segment then fails every comparison that matters: the
 * access check reads "production%20toolkit" and the token grants
 * "Production Toolkit", so the route resolves to the not-found page.
 *
 * This is the single place the two spellings are reconciled. Apply it when
 * building a link and on both sides of any comparison — never store the result
 * as the display name.
 *
 * Whitespace is *removed* rather than turned into a hyphen: the module registry
 * keys predate this helper ("productiontoolkit", "station60"), and one of them
 * ("tpi-sync") carries a meaningful hyphen that a space-to-hyphen rule would
 * make ambiguous.
 *
 *   "Production Toolkit" -> "productiontoolkit"
 *   "Station 60"         -> "station60"
 *   "TPI-Sync"           -> "tpi-sync"
 *   "thinkgas"           -> "thinkgas"          (no-op for existing names)
 *
 * @param {unknown} value name from a token, URL segment, or registry key
 * @returns {string} slug, or "" when there's nothing to slug
 */
export const toRouteSlug = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "")

export default toRouteSlug
